import React from 'react'

export default function Expired() {
    return (
        <div>
            expired
        </div>
    )
}
